__turbopack_context__.v({
  "className": "nunito_faf8bdde-module__ZdPV6W__className",
  "variable": "nunito_faf8bdde-module__ZdPV6W__variable",
});
